import { v4 as uuidv4 } from 'uuid';
import { HomePath } from './home-path';

export const products = [

    {
        id: 'item-1',
        sex: 'womens',
        type: 'shoes',
        name: 'running shoes',
        img: 'https://images.pexels.com/photos/4767907/pexels-photo-4767907.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'asics'
    },
    {
        id: 'item-2',
        sex: 'womens',
        type: 'shoes',
        name: 'running shoes',
        img: 'https://images.pexels.com/photos/8520627/pexels-photo-8520627.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: true,
        brand: 'athletix'
    },
    {
        id: 'item-3',
        sex: 'womens',
        type: 'shirt',
        name: 'cropped top',
        img: 'https://images.pexels.com/photos/10371088/pexels-photo-10371088.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 110,
        colors: ['white', 'black'],
        recommended: true,
        brand: 'athletix'
    },
    {
        id: 'item-4',
        sex: 'womens',
        type: 'shorts',
        name: 'jogging shorts',
        img: 'https://images.pexels.com/photos/3764533/pexels-photo-3764533.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 60,
        colors: ['black', 'white'],
        recommended: true,
        brand: 'adidas'
    },
    {
        id: 'item-5',
        sex: 'womens',
        type: 'shirt',
        name: 'Logo t-shirt',
        img: 'https://images.pexels.com/photos/3268529/pexels-photo-3268529.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 35,
        colors: ['white', 'black'],
        recommended: false,
        brand: 'adidas'
    },
    {
        id: 'item-6',
        sex: 'womens',
        type: 'jacket',
        name: 'lifestyle jacket',
        img: 'https://images.pexels.com/photos/4804447/pexels-photo-4804447.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 110,
        colors: ['black', 'white'],
        recommended: true,
        brand: 'adidas'
    },
    {
        id: 'item-7',
        sex: 'mens',
        type: 'shoes',
        name: 'street wear sneakers',
        img: 'https://images.pexels.com/photos/1280064/pexels-photo-1280064.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 190,
        colors: ['brown', 'orange'],
        recommended: true,
        brand: 'adidas'
    },
    {
        id: 'item-8',
        sex: 'womens',
        type: 'shoes',
        name: 'street wear sneakers',
        img: 'https://images.pexels.com/photos/10657969/pexels-photo-10657969.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 110,
        colors: ['white', 'white'],
        recommended: true,
        brand: 'adidas'
    },
    {
        id: 'item-9',
        sex: 'mens',
        type: 'outerwear',
        name: 'Casual jacket',
        img: 'https://images.pexels.com/photos/1192601/pexels-photo-1192601.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'adidas'
    },
    {
        id: 'item-10',
        sex: 'mens',
        type: 'shoes',
        name: 'Street casual Basketball shoes 3',
        img: 'https://images.pexels.com/photos/5584997/pexels-photo-5584997.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'jordan'
    },
    {
        id: 'item-11',
        sex: 'mens',
        type: 'shoes',
        name: 'Streetwear shoes',
        img: 'https://images.pexels.com/photos/9869141/pexels-photo-9869141.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 90,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-12',
        sex: 'mens',
        type: 'shirt',
        name: 'logo and text t-shirt',
        img: 'https://images.pexels.com/photos/10758260/pexels-photo-10758260.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 35,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'puma'
    },
    {
        id: 'item-13',
        sex: 'mens',
        type: 'shoes',
        name: 'running shoes',
        img: 'https://images.pexels.com/photos/8858120/pexels-photo-8858120.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'asics'
    },
    {
        id: 'item-14',
        sex: 'mens',
        type: 'shoes',
        name: 'streetwear sneaker',
        img: 'https://images.pexels.com/photos/6748252/pexels-photo-6748252.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 90,
        colors: ['navy', 'white'],
        recommended: false,
        brand: 'asics'
    },
    {
        id: 'item-15',
        sex: 'mens',
        type: 'shoes',
        name: 'casual shoe',
        img: 'https://images.pexels.com/photos/9342603/pexels-photo-9342603.png?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 90,
        colors: ['white', 'white'],
        recommended: false,
        brand: 'asics'
    },
    {
        id: 'item-16',
        sex: 'womens',
        type: 'outerwear',
        name: 'tech jacket',
        img: 'https://images.pexels.com/photos/11955127/pexels-photo-11955127.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 100,
        colors: ['white', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-17',
        sex: 'kids',
        type: 'outerwear',
        name: 'jacket',
        img: 'https://images.pexels.com/photos/10371082/pexels-photo-10371082.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 100,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-18',
        sex: 'mens',
        type: 'outerwear',
        name: 'coach jacket',
        img: 'https://images.pexels.com/photos/7741187/pexels-photo-7741187.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 100,
        colors: ['red', 'white'],
        recommended: true,
        brand: 'athletix'
    },
    {
        id: 'item-19',
        sex: 'kids',
        type: 'outerwear',
        name: 'acg fleece',
        img: 'https://images.pexels.com/photos/1992879/pexels-photo-1992879.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 100,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-20',
        sex: 'mens',
        type: 'shoes',
        name: 'training shoes',
        img: 'https://images.pexels.com/photos/1456705/pexels-photo-1456705.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 40,
        colors: ['black', 'white'],
        recommended: true,
        brand: 'athletix'
    },
    {
        id: 'item-21',
        sex: 'mens',
        type: 'shirt',
        name: 'casual t-shirt',
        img: 'https://images.pexels.com/photos/6739730/pexels-photo-6739730.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 40,
        colors: ['black', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-22',
        sex: 'mens',
        type: 'shirt',
        name: 'logo t-shirt',
        img: 'https://images.pexels.com/photos/2062342/pexels-photo-2062342.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 40,
        colors: ['white', 'black'],
        recommended: true,
        brand: 'puma'
    },
    {
        id: 'item-23',
        sex: 'womens',
        type: 'shoes',
        name: 'all weather sneaker',
        img: 'https://images.pexels.com/photos/13442080/pexels-photo-13442080.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 40,
        colors: ['purple', 'white'],
        recommended: true,
        brand: 'puma'
    },
    {
        id: 'item-24',
        sex: 'mens',
        type: 'shoes',
        name: 'limited signature shoe',
        img: 'https://images.pexels.com/photos/2759783/pexels-photo-2759783.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 90,
        colors: ['white', 'multi'],
        recommended: false,
        brand: 'puma'
    },
    {
        id: 'item-25',
        sex: 'mens',
        type: 'shoes',
        name: 'signature sneaker',
        img: 'https://images.pexels.com/photos/5967666/pexels-photo-5967666.png?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 90,
        colors: ['red', 'white'],
        recommended: true,
        brand: 'puma'
    },
    {
        id: 'item-26',
        sex: 'womens',
        type: 'shoes',
        name: 'road running shoe',
        img: 'https://images.pexels.com/photos/4971001/pexels-photo-4971001.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['black', 'white'],
        recommended: true,
        brand: 'asics'
    },
    {
        id: 'item-27',
        sex: 'womens',
        type: 'shoes',
        name: 'Court Basketball Shoe',
        img: 'https://images.pexels.com/photos/5413301/pexels-photo-5413301.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['green', 'black'],
        recommended: false,
        brand: 'jordan'
    },
    {
        id: 'item-28',
        sex: 'womens',
        type: 'athletic',
        name: 'golf skirt',
        img: 'https://images.pexels.com/photos/13707168/pexels-photo-13707168.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 75,
        colors: ['beige', 'white'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-29',
        sex: 'womens',
        type: 'athletic',
        name: 'sports bra',
        img: 'https://images.pexels.com/photos/8502210/pexels-photo-8502210.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 35,
        colors: ['pink', 'white'],
        recommended: true,
        brand: 'athletix'
    },
    {
        id: 'item-30',
        sex: 'mens',
        type: 'shirt',
        name: 'casual t-shirt',
        img: 'https://images.pexels.com/photos/4378854/pexels-photo-4378854.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 25,
        colors: ['white', 'black'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-31',
        sex: 'mens',
        type: 'shoes',
        name: 'Basketball Street 5s',
        img: 'https://images.pexels.com/photos/6050920/pexels-photo-6050920.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 25,
        colors: ['off-white', 'black'],
        recommended: false,
        brand: 'jordan'
    },
    {
        id: 'item-32',
        sex: 'mens',
        type: 'shirt',
        name: 'athletic short sleeve',
        img: 'https://images.pexels.com/photos/13142701/pexels-photo-13142701.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 40,
        colors: ['white', 'black'],
        recommended: false,
        brand: 'athletix'
    },
    {
        id: 'item-33',
        sex: 'mens',
        type: 'shoes',
        name: 'running shoes',
        img: 'https://images.pexels.com/photos/1456737/pexels-photo-1456737.jpeg?auto=compress&cs=tinysrgb&w=1600',
        route: HomePath + '/product',
        price: 70,
        colors: ['white', 'black'],
        recommended: false,
        brand: 'athletix'
    },

];